var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.show)?_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择区域","props":_vm.props},on:{"change":_vm.handleChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }